import { ROUTES } from "./constants"
import { getPosvUrl } from "./getDevice"

export const handleProgress = (width) => {
    const statusEl = document.getElementById('status-bar')
    if (statusEl) {
        statusEl.style.width = `${width}%`
    }
    // let width = 5
    // let progressInterval = setInterval(()=>{
    //     width+=5
    //     if(width>100){
    //         clearInterval(progressInterval)
    //     }else{
    //         statusEl.style.width = `${width}%` 
    //     }
    // },1000)
}

export const isNewUI = () => {
    let showNewUI = localStorage.getItem('showNewUI')
    if (showNewUI) {
        if (showNewUI === 'Y') {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}

export const isPODPosv = () => {
    const otpOnlyPosv = localStorage.getItem('otpOnlyPosv')
    if (otpOnlyPosv) {
        if (otpOnlyPosv === 'Y') {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}

export const isSeniorCitizen = () => {
    const isSeniorCitizen = localStorage.getItem('seniorCitizen')
    if (isSeniorCitizen) {
        if (isSeniorCitizen === 'Y') {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
};

export const generateVideoThumbnail = async(fileParts) => {
    let blob = new Blob(fileParts, { 'type': 'video/mp4;' });
    const { base64data, videoInFileFormat } = await blobToBase64(blob)
    return new Promise((resolve) => {
        const canvas = document.createElement("canvas");
        const video = document.createElement("video");
        video.autoplay = true;
        video.muted = true;
        video.src = URL.createObjectURL(videoInFileFormat);
        video.onloadeddata = () => {
            let ctx = canvas.getContext("2d");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
            video.pause();
            return resolve(canvas.toDataURL("image/png"));
        };
    });
};

const blobToBase64 = (blobFile) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(blobFile);
        reader.onloadend = () => {
            let base64data = reader.result;
            let videoInFileFormat = dataURLtoFile(base64data, "My_recording.mp4")
            resolve({ base64data, videoInFileFormat })
        }
    })
}


const dataURLtoFile = (dataurl, filename) => {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}

export const redirectToVerify =(router)=>{
    let txnId = sessionStorage.getItem('txnId') ? sessionStorage.getItem('txnId') : undefined
    let url = getPosvUrl(txnId);
    // console.log('url',url);
    window.open(url, '_self')
    // router.replace(`/vu?id=${txnId}`)
}

export const hideProgressBar = () => {
    const statusEl = document.querySelector('.bar-cntnr')
    if (statusEl) {
        statusEl.style.display = 'none';
    }
}

export const getRedirectionRouteForPosv = () => {
    let url = "";
    const simplifiedJourney = localStorage.getItem("simplifiedJourney");
    const isVideoPosv = localStorage.getItem("isVideoPosv");
    const category = localStorage.getItem("category");
    if (simplifiedJourney?.toLocaleLowerCase() == 'y') {
        if (isVideoPosv === "Y") {
            url = `/video-verification`;
        } else {
            url = `/customer_feedback`;
        }
    }
    else {
        if (isVideoPosv === "Y") {
            url = `/video-verification?page=${category}`;
        } else {
            url = `/customer_feedback?page=${category}`;
        }
    }

    return url;
}

export const getCurrentStepLabelForTB = (currentPath) => {
    switch (currentPath) {
        case ROUTES.PERSONAL_DETAILS:
            return {
                step: "1",
                label: "Personal Details"
            }
        case ROUTES.PAYMENT:
            return {
                step: "5",
                label: "Payment"
            }
        case "/selfie":
            return {
                step: "3",
                label: "Photo Verification"
            }
        case "/video-consent":
            return {
                step: "4",
                label: "Video Consent"
            }
        case "/generate_otp":
            return {
                step: "4",
                label: "Required Consent"
            }
        case "/customer_feedback":
        case "/video-verification":
            return {
                step: "2",
                label: "Proposal Review"
            }
        default:
            return {
                step: "",
                label: ""
            }
    }
}
